.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  background: #fffdf7;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.heading {
  font-size: 22px;
  font-weight: 300;
  text-align: center;
  color: #505050;
  margin: 0;
}

@media (max-width: 900px) {
  .container {
    max-width: 100%;
    padding: 16px;
    border-radius: 0;
  }
}

@media (max-width: 600px) {
  .heading {
    font-size: 18px;
  }
}
